import request from "./request";

const alzheimerService = {
  // Question Assessment
  createQuestion: (data) => request.post('/', data),
  getAllQuestions: () => request.get('/'),
  getQuestionById: (id) => request.get(`/${id}`),
  updateQuestion: (id, data) => request.put(`/${id}`, data),
  deleteQuestion: (id) => request.delete(`/${id}`),
                            
   // Question-Category Assessment
  createQuestionCategory: (data) => request.post('/', data),
  getAllQuestionCategorys: () => request.get('/'),
  getQuestionCategoryById: (id) => request.get(`/${id}`),
  updateQuestionCategory: (id, data) => request.put(`/${id}`, data),
  deleteQuestionCategory: (id) => request.delete(`/${id}`),

  // Videos
  createVideo: (data) => request.post('/assesment/alzheimer/videos', data),
  getAllVideos: () => request.get('/assesment/alzheimer/videos?sort=old'),
  deleteVideo: (id) => request.delete(`/${id}`),

  // Meditation
  createMeditation: (data) => request.post('/', data),
  getAllMeditations: () => request.get('/'),
  getMeditationById: (id) => request.get(`/${id}`),
  deleteMeditation: (id) => request.delete(`/${id}`),

  // Task
  createTask: (data) => request.post('/', data),
  getAllTasks: () => request.get('/'),
  getTaskById: (id) => request.get(`/${id}`),
  updateTask: (id, data) => request.put(`/${id}`, data),
  deleteTask: (id) => request.delete(`/${id}`),

  // Activities
  createActivity: (data) => request.post('/', data),
  getAllActivities: () => request.get('/'),
  getActivityById: (id) => request.get(`/${id}`),
  updateActivity: (id, data) => request.put(`/${id}`, data),
  deleteActivity: (id) => request.delete(`/${id}`),

  // Games
  createGame: (data) => request.post('/', data),
  getAllGames: () => request.get('/'),
  getGameById: (id) => request.get(`/${id}`),
  updateGame: (id, data) => request.put(`/${id}`, data),
  deleteGame: (id) => request.delete(`/${id}`),

  // Doctors
  createDoctor: (data) => request.post('/assesment/alzheimer/doctors', data),
  getAllDoctors: () => request.get('/admin/getAllDoctors'),
  getDoctorById: (id) => request.get(`/${id}`),
  updateDoctor: (id, data) => request.put(`/${id}`, data),
  deleteDoctor: (id) => request.delete(`/${id}`),
};

export default alzheimerService;